// App utils
import { datajs } from '../shared/utils';

(function() {
	const removeCookieNotice = e => {
		e.preventDefault();

		// Set a cookie
		document.cookie = 'efs-vasterbottenCookieConsent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
		datajs('cookie-consent')[0].classList.add('is-hiding');
	};

	const cookieConsent = () => {
		// Close Click hander
		datajs('accept-cookie-information').forEach(item => item.addEventListener('click', removeCookieNotice));

		// Show cookie consent
		if (document.cookie.replace(/(?:(?:^|.*;\s*)efs-vasterbottenCookieConsent\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'true') {
			datajs('cookie-consent')[0].style.display = 'block';
		}
	};

	document.addEventListener('DOMContentLoaded', cookieConsent);
})();
